/**
 * 获取完整的资源 URL（头像、图片等）
 * @param path - 资源路径（可能是相对路径或完整 URL）
 * @returns 完整的 URL
 */
export function getAvatarUrl(path: string | undefined): string {
  if (!path) {
    return '';
  }
  
  // 如果已经是完整 URL，直接返回
  if (path.startsWith('http')) {
    return path;
  }
  
  // 如果是相对路径，拼接基础 URL
  const baseURL = (import.meta as { env?: { VITE_API_BASE_URL?: string } }).env?.VITE_API_BASE_URL || '';
  
  // 如果 path 以 /api/v1 开头，去掉 /api/v1 部分再拼接
  if (path.startsWith('/api/v1')) {
    return `${baseURL.replace('/api/v1', '')}${path}`;
  }
  
  // 其他相对路径
  return `${baseURL}${path}`;
}

/**
 * 获取完整的图片 URL（反馈图片等）
 * @param path - 图片路径（可能是相对路径或完整 URL）
 * @returns 完整的 URL
 */
export function getImageUrl(path: string | undefined): string {
  return getAvatarUrl(path);
}
